(function () {

    "use strict";

    var dependencies = ['$q', '$filter', 'interviewBankDataService'];

    function VideoReviewerForm(formName) {
        var self = this;
        var $q = dependencies['$q'];
        var $filter = dependencies["$filter"];
        var interviewBankDataService = dependencies["interviewBankDataService"];

        self.data = {};

        self.scoreOptions = [
            {
                name: '1',
                value: 1
            },
            {
                name: '2',
                value: 2
            },
            {
                name: '3',
                value: 3
            },
            {
                name: '4',
                value: 4
            },
            {
                name: '5',
                value: 5
            }
        ];

        self.load = function (data) {
            self.data = data;
        };

        self.addReview = function () {
            if (self.validator.validate()) {
                var param = {
                    score: self.data.score,
                    notes: self.data.comment_text
                };

                self.evaluating = true;
                interviewBankDataService.postReview(self.data.brandId, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW,
                    self.data.applicantId, self.data.interviewId, self.data.selectedQuestion.id, self.data.selectedQuestion.answer.id,
                    param, self.index)
                    .then(function (res) {
                        delete self.data.score;
                        delete self.data.comment_text;
                    })
                    .catch(function (err) {
                        console.error(err);
                    })
                    .finally(function () {
                        self.evaluating = false;
                    });
            }
        };

        self.cancel = function () {};

        self.onSelectQuestion = function (id, index) {
            self.data.selectedQuestion = _.find(self.data.questions, function (item) {
                return item.id === id;
            });
            self.index = index;
            delete self.data.score;
            delete self.data.comment_text;
        };
    }

    angular
        .module("harriApp")
        .run(['hFormsService', function (hFormsService) {

            hFormsService.registerForm("videoReviewerForm", {
                form: VideoReviewerForm,
                dependencies: dependencies
            });
        }]);
})();